import CrudPage from '@modules/cruds/CrudPage';

import * as yup from 'yup';
import ParameterForm from './ParameterForm';
import { IConfigComponent } from '@ts/ui-models';
import { useAppDispatch, useAppSelector } from '@redux/store';
import { getSettings } from '@services/ApiService';

const paramSchema = yup.object().shape({
  name: yup.string().required().label('Name'),
});

const ParameterPage = props => {
  const dispatch = useAppDispatch();
  const badge = useAppSelector(state => state.global.sessionBadge);

  const defaultConfigComponent: IConfigComponent = {
    componentId: 'taParameter',
    aclId: 'taView',
    entity: 'parameter',
    fetchURL: '/api/parameter',
  };

  const extraActionToDoAfterCorrectSubmit = async (_values, _options) => {
    if (!badge) return;

    await getSettings(dispatch, badge);
  };

  return (
    <CrudPage
      key={'labelPage'}
      configComponent={defaultConfigComponent}
      form={ParameterForm}
      validationSchema={paramSchema}
      extraActionToDoAfterCorrectSubmit={extraActionToDoAfterCorrectSubmit}
    />
  );
};

export default ParameterPage;

/* const React = require('react');
import ParameterForm from './ParameterForm';

const PropTypes = require('prop-types');
const createReactClass = require('create-react-class');
const App = require('@gral/app');
const { set } = require('lodash');
const Immutable = require('immutable');
const act = require('@flux/actions/actView');
const Mixin = require('@utils/mixin/mixin');
const EditPage = require('@pages/EditPage').default;

// -=======================================================
const ParameterPage = createReactClass({
  displayName: 'ParameterPage',
  mixins: [Mixin.Base, Mixin.Needs],
  propTypes: {
    app: PropTypes.object.isRequired,
    data: PropTypes.object.isRequired,
  },

  render() {
    const additionalProps = {
      fnPrepareSave: attrs => {
        attrs.currentOrganizationId = App.cxStore.getOrganizationId();
        let err;
        if (attrs.value && attrs.value.predefinedFilter != null) {
          if (typeof attrs.value.predefinedFilter !== 'object') {
            try {
              attrs.value.predefinedFilter = JSON.parse(attrs.value.predefinedFilter);
            } catch (error2) {
              err = error2;
              act.notify({
                msg: this.props.t('Invalid JSON format in Predefined filter, please check!'),
              });
              throw err;
            }
          }
        }
        if (attrs?.value?.value != null) {
          // custom setting
          if (attrs.value.key == 'rowsPerPage') {
            const parsedValue = parseInt(attrs.value.value, 10);
            if (!Number.isInteger(parsedValue)) {
              act.notify({
                msg: this.props.t('Invalid value, expected integer'),
              });
              return;
            }
            attrs.value.value = parsedValue;
          }
        }
        if (attrs?.parameterTypeId === 'app_mobileAppSettings' || attrs?.parameterTypeId === 'organization_mobileAppSettings') {
          try {
            if (typeof attrs.value.items === 'string') {
              attrs.value.items = JSON.parse(attrs.value.items);
            }
            if (typeof attrs.value.itemTypes === 'string') {
              attrs.value.itemTypes = JSON.parse(attrs.value.itemTypes);
            }
          } catch (error) {
            err = error;
            act.notify({
              msg: this.props.t('Invalid JSON format, please check!'),
            });
            throw err;
          }
        }

        if (attrs?.name === 'mobileSnapshotCreationSchedule') {
          if (attrs.value.schedule === '* * * * *') {
            act.notify({
              msg: this.props.t('Please select a schedule that ensures a snapshot is created at least once per week.'),
            });
            throw new Error('CRON EXPRESSION ERROR: * * * * *!');
          }
        }

        act.markAsStale('parameterTypesAvailable');
        return attrs;
      },
      fnInitState(state) {
        const out = {};
        const value = Immutable.isImmutable(state.value) ? state.value.toJS() : state.value;
        if (value && value.menu != null) {
          set(out, 'value.menu', JSON.stringify(value.menu, null, 2));
        }
        if (value && value.colourSet != null) {
          set(out, 'value.colourSet', JSON.stringify(value.colourSet, null, 2));
        }
        if (value && value.predefinedFilter != null) {
          set(out, 'value.predefinedFilter', JSON.stringify(value.predefinedFilter, null, 2));
        }
        if (value && value.value != null) {
          set(out, 'value.key', value.key);
          set(out, 'value.value', JSON.stringify(value.value, null, 2));
        }
        return null;
      },
    };

    return (
      <EditPage
        {...Object.assign(
          {},
          this.props,
          {
            modelName: 'parameter',
            collectionDataPath: 'parameters',
            FormComponent: ParameterForm,
            fOnSaveGoBack: true,
            fNewButton: false,
            fDeleteButton: false,
            reloadSettings: true,
          },
          additionalProps
        )}
      />
    );
  },
});

export default ParameterPage;
 */
